<template>
    <c-dialog ref="dialog" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <c-detail class="m-detail-form">
            <c-detail-item label="服务时间">
                <b>{{detailData.appointment_start_time}}</b> ~ <b>{{detailData.appointment_end_time}}</b>
            </c-detail-item>
            <c-detail-item label="服务天数">
                {{detailData.estimated_service_days}}天
            </c-detail-item>
            <c-detail-item label="住宿天数">
                {{detailData.accommodation_days}}夜
            </c-detail-item>
            <c-detail-item label="服务人数">
                {{detailData.estimated_technician_count}}人
            </c-detail-item>
            <c-detail-item label="出行方式">
                <c-state dict="travelModeOptions" tag :value="detailData.travel_mode"></c-state>
            </c-detail-item>
            <c-detail-item label="总费用">
                ￥{{estimatedCostJson.estimated_cost_total}}
            </c-detail-item>
            <c-detail-item label="车辆费用" v-if="carList && carList.length > 0">
                <c-table ref="carListTable" border :paging="false">
                    <c-table-column name="fee_type_name" label="费用支出项目" width="50" summed>
                        <template #summed>
                            <span>合计：</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="unit_price" label="定额标准" width="50">
                        <template #default="{data}">
                            <span>{{data.unit_price.toFixed(2)}} {{data.calc_unit}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="amount" label="小计金额" width="50" :summed="({data}) => data.amount">
                        <template #default="{data}">
                            <span>{{data.amount.toFixed(2)}} 元</span>
                        </template>
                        <template #summed="{total}">
                            <span>{{total.toFixed(2)}} 元</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="remark" label="备注" width="300">
                    </c-table-column>
                </c-table>
            </c-detail-item>
            <c-detail-item label="员工费用" v-if="userList && userList.length > 0">
                <c-table ref="userListTable" border :paging="false">
                    <c-table-column name="fee_type_name" label="费用支出项目" width="50" summed>
                        <template #summed>
                            <span>合计：</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="unit_price" label="定额标准" width="50">
                        <template #default="{data}">
                            <span v-if="data.multiplier > 1" style="color: red">{{((data.unit_price)*(data.multiplier)).toFixed(2)}} {{data.calc_unit}}</span>
                            <span v-else>{{data.unit_price.toFixed(2)}} {{data.calc_unit}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="amount" label="小计金额" width="50" :summed="({data}) => data.amount">
                        <template #default="{data}">
                            <span>{{data.amount.toFixed(2)}} 元</span>
                        </template>
                        <template #summed="{total}">
                            <span>{{total.toFixed(2)}} 元</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="remark" label="备注" width="300">
                    </c-table-column>
                </c-table>
            </c-detail-item>
            <c-detail-item label="设备费用" v-if="equipmentList && equipmentList.length > 0">
                <c-table ref="equipmentListTable" border :paging="false">
                    <c-table-column name="fee_type_name" label="费用支出项目" width="50" summed>
                        <template #summed>
                            <span>合计：</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="定额标准" width="50">
                        <template #default="{data}">
                            <span>{{data.unit_price.toFixed(2)}} {{data.calc_unit}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="amount" label="小计金额" width="50" :summed="({data}) => data.amount">
                        <template #default="{data}">
                            <span>{{data.amount.toFixed(2)}} 元</span>
                        </template>
                        <template #summed="{total}">
                            <span>{{total.toFixed(2)}} 元</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="remark" label="备注" width="300">
                    </c-table-column>
                </c-table>
            </c-detail-item>
        </c-detail>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'estimatedCostDetail',

    data() {
        return {
            detailData:{},
            estimatedCostJson:{},
            carList:[],
            userList:[],
            equipmentList:[],
        }
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['travelModeOptions'])
    },
    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.detailData = data;
            this.estimatedCostJson = data.estimated_cost_json;
            this.carList = this.estimatedCostJson.estimated_cost_list.filter(item => item.fee_category == 1);
            this.userList = this.estimatedCostJson.estimated_cost_list.filter(item => item.fee_category == 2);
            this.equipmentList = this.estimatedCostJson.estimated_cost_list.filter(item => item.fee_category == 3);
            this.$nextTick(() => {
                if (this.carList && this.carList.length > 0){
                    this.$refs.carListTable.setData(this.carList);
                }
                if (this.userList && this.userList.length > 0){
                    this.$refs.userListTable.setData(this.userList);
                }
                if (this.equipmentList && this.equipmentList.length > 0){
                    this.$refs.equipmentListTable.setData(this.equipmentList);
                }
            })
            //填充form表单
            this.$refs.dialog.open({
                title: '工单【'+data.order_number+'】预估成本明细'
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>